// Notice Action Types
export const NOTICE_GET_ALL = "NOTICE_GET_ALL";
export const NOTICE_SET_FILTERS = "NOTICE_SET_FILTERS";
export const NOTICE_CLEAR_FILTERS = "NOTICE_CLEAR_FILTERS";
export const NOTICE_SET_STATE = "NOTICE_SET_STATE";
export const NOTICE_PAGE_RESET = "NOTICE_PAGE_RESET";
export const NOTICE_SET_LOADING = "NOTICE_SET_LOADING";
export const NOTICE_SET_ERROR = "NOTICE_SET_ERROR";

// Create notice action types
export const NOTICE_CREATE = "NOTICE_CREATE";
export const NOTICE_CREATE_SUCCESS = "NOTICE_CREATE_SUCCESS";
export const NOTICE_CREATE_FAILURE = "NOTICE_CREATE_FAILURE";